import { useState, useEffect, useRef } from "react";
import {
  ExtendedBioTopics,
  SocketTopics,
  SurveyQuestionTopics,
  PageTopics,
  CADSectionTopics,
  BioTopics,
} from "../constants/enums";
import { useSelector } from "react-redux";
import useSocketActions from "./socketActions";
import mqtt from "mqtt";
import { generateUUID } from "utils/appUtil";
import { useLocation } from "react-router-dom";
import { wrapRequestPayload } from "../helpers/request/RequestPayload";
import { RootState } from "reducers/rootReducer";

const MQTTPattern = require("mqtt-pattern");

export default () => {
  const [socketClient, setSocketClient] = useState<any>();
  const [connectedClient, setConnectedClient] = useState<any>();
  const { encrypted_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { search } = useLocation();
  const {
    getSurveyList,
    getSectionList,
    getBio,
    getRoleList,
    getExtendedBioList,
    getVehicleExtendedBioList,
    getProjectList,
    getRespondersList,
    getAssetsList,
    setSubmitted,
    getPageResult,
    handlePageEot,
    getUsersList,
    handleMessages,
    handleAppendMessage,
    handleUserBds,
    handleAggregateBds,
    handlePageResults,
    handleAggregate,
    getAccountsList,
  } = useSocketActions();
  const callbacks = useRef<any>({});
  const surveyTopicIds = useRef<any>({});

  const socketConnect = () => {
    setSocketClient(
      mqtt.connect(process.env.REACT_APP_BASE_WS_URL, {
        clientId: generateUUID(),
        username: "live",
        password: "beamL1ve",
      })
    );
  };

  useEffect(() => {
    return () => {
      if (socketClient) {
        socketClient.end(undefined, undefined, () => {
          console.log("Disconnected");
        });
      }
    };
  }, []);

  useEffect(() => {
    if (socketClient) {
      socketClient.on("connect", () => {
        console.log("Connected");
        setConnectedClient(socketClient);
      });
      socketClient.on("error", (err) => {
        console.error("Connection error: ", err);
        socketClient.end();
      });
      socketClient.on("reconnect", () => {
        console.log("Reconnecting");
      });
      socketClient.on("disconnect", () => {
        console.log("Disconnecting");
      });
      socketClient.on("message", socketMessageReceivedListener);
    }
  }, [socketClient]);

  const publishToEventServiceIdSurvey = (
    event: SocketTopics,
    topic: string,
    data: IPublishRequest,
    subscribePath: string,
    serviceId: string,
    callback: any = () => {}
  ) => {
    // const query = new URLSearchParams(search);
    const wrappedData = wrapRequestPayload(data);
    // const connectionId = encrypted_token?.connectionId || query.get("connectionId");
    const searchTopic = `${process.env.REACT_APP_ECO_SYSTEM}/service/dps/service/${serviceId}/${topic}`;
    if (socketClient) {
      socketClient.subscribe(`${searchTopic}/reply`, { qos: 1 }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        surveyTopicIds.current[wrappedData.id] = subscribePath;
      });
      socketClient.publish(
        searchTopic,
        JSON.stringify(wrappedData),
        { qos: 1 },
        (error) => {
          if (error) {
            callback({ status: false });
          } else {
            callback({ status: true });
          }
        }
      );
    }
  };

  const subscribeToEventSurvey = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {},
    componentUuid?: string
  ) => {
    if (!callbacks.current[topic]) callbacks.current[topic] = [];
    const index = callbacks.current[topic].findIndex((x) => {
      return x.componentUuid === componentUuid;
    });
    if (index !== -1) {
      callbacks.current[topic][index] = {
        componentUuid,
        callback,
      };
    } else {
      callbacks.current[topic].push({
        componentUuid,
        callback,
      });
    }
  };

  const publishToEvent = (
    event: SocketTopics,
    topic: string,
    data: IPublishWrapRequest | IPublishRequest,
    callback: any = () => {}
  ) => {
    if (socketClient) {
      socketClient.publish(topic, JSON.stringify(data), { qos: 1 }, (error) => {
        if (error) {
          callback({ status: false });
        } else {
          callback({ status: true });
        }
      });
    }
  };

  const subscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {},
    componentUuid?: string
  ) => {
    if (socketClient) {
      socketClient.subscribe(topic, { qos: 1 }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        // if (topic?.includes("user")) {
        //   console.log("subscribe user topic", topic);
        // }
        // if(!callbacks.current[topic])callbacks.current[topic] = []
        // callbacks.current[topic].push(callback);

        if (!callbacks.current[topic]) callbacks.current[topic] = [];
        const index = callbacks.current[topic].findIndex((x) => {
          return x.componentUuid === componentUuid;
        });
        if (index !== -1) {
          callbacks.current[topic][index] = {
            componentUuid,
            callback,
          };
        } else {
          callbacks.current[topic].push({
            componentUuid,
            callback,
          });
        }
      });
    }
  };

  const unSubscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {}
  ) => {
    if (socketClient) {
      socketClient.unsubscribe(topic, (error) => {
        if (error) {
          console.log("unSubsribed to topics error", error);
          return;
        }
      });
    }
  };

  const socketMessageReceivedListener = (topic: string, message: any) => {
    const payload = { topic, message: message.toString() };
    if(!payload.message)return;

    console.log('payload', payload);
    
    let data = JSON.parse(payload.message);
    if (surveyTopicIds.current?.[data.id]) {
      topic = surveyTopicIds.current[data.id];
      data = data.response;
    }
    Object.keys(callbacks?.current || {}).map((callbackTopic) => {
      if (MQTTPattern.matches(callbackTopic, topic)) {
        callbacks?.current?.[callbackTopic].map(({callback}) => {
          callback(data);
        });
      }
    });

    // if (callbacks?.current?.[topic]) {
    //   callbacks?.current?.[topic](data);
    // }
    if (topic === CADSectionTopics.GetSectionList) {
      getSectionList(data);
    }
    if (topic === BioTopics.GetBio) {
      getBio(data);
    }
    if (topic === BioTopics.GetRoleList) {
      getRoleList(data);
    }
    if (topic === SurveyQuestionTopics.GetSurveyQuestions) {
      getSurveyList(data);
    }
    if (topic === ExtendedBioTopics.GetRolesBio) {
      getExtendedBioList(data);
    }
    if (topic === ExtendedBioTopics.GetVehicleBio) {
      getVehicleExtendedBioList(data);
    }
    if (topic.includes(PageTopics.GetProjectsResult)) {
      getProjectList(data.response);
    }
    if (topic.includes(PageTopics.GetAccountsResult)) {
      getAccountsList(data.response);
    }
    if (topic.includes(PageTopics.GetRespondersResult)) {
      getRespondersList(data.response);
    }
    if (topic.includes(PageTopics.GetAssetsResult)) {
      getAssetsList(data.response);
    }
    if (
      topic.includes(PageTopics.CreateEventResult) ||
      topic.includes(PageTopics.CreateTicketResult) ||
      topic.includes(PageTopics.CreateRideResult)
    ) {
      setSubmitted(data.response);
    }
    if (topic.includes(PageTopics.SearchPageResult)) {
      getPageResult(data);
    }
    if (topic.includes(PageTopics.BdsEot)) {
      handlePageEot({ subscribeToEvent, publishToEvent }, topic, data);
    }
    if (topic.includes(PageTopics.SearchUser)) {
      getUsersList(data.id, data.response);
    }
    if (topic.includes(PageTopics.SearchMessage)) {
      handleMessages(data.id, data.response);
    }
    if (topic.includes(PageTopics.GroupMembers)) {
      handleAppendMessage(data);
    }
    if (topic.includes(PageTopics.SearchBds)) {
      handleUserBds(data);
    }
    if (topic.includes(PageTopics.GetPageAggregateBds)) {
      handleAggregateBds(data);
    }
    if (topic.includes(PageTopics.GetPageResult)) {
      handlePageResults(data);
    }
    if (
      topic.includes(PageTopics.GetAggregateBds) &&
      topic.includes(PageTopics.Connection)
    ) {
      handleAggregate(data);
    }
  };

  return {
    socketClient: connectedClient,
    socketConnect,
    subscribeToEventSurvey,
    publishToEventServiceIdSurvey,
    socketSubscribeToEvent: subscribeToEvent,
    socketUnSubscribeToEvent: unSubscribeToEvent,
    socketPublishToEvent: publishToEvent,
  };
};
